<div class="spacer-top">
<span class="input-group" style="display: inline" ng-model="vm.keywords">
    <span ng-repeat="kw in vm.keywords | filter: {active: '!'+false}" style="display: inline;">
      <span uib-dropdown>
        <button type="button"
                class="btn btn-{{kw.col}}" uib-dropdown-toggle
                data-toggle="uib-dropdown"
                aria-haspopup="true" aria-expanded="false">
          {{kw.key}} <span class="caret"></span>
        </button>
        <ul uib-dropdown-menu>
          <li>
            <a ng-click="vm.updateColor(kw,'success')">
              <span class="label label-success">{{vm.customlabels['success']}}</span>
            </a>
          </li>
          <li>
            <a ng-click="vm.updateColor(kw,'warning')">
              <span class="label label-warning">{{vm.customlabels['warning']}}</span>
            </a>
          </li>
          <li>
            <a ng-click="vm.updateColor(kw,'danger')">
              <span class="label label-danger">{{vm.customlabels['danger']}}</span>
            </a>
          </li>
          <li>
            <a ng-click="vm.updateColor(kw,'info')">
              <span class="label label-info">{{vm.customlabels['info']}}</span>
            </a>
          </li>
          <li>
            <a ng-click="vm.updateColor(kw,'primary')">
              <span class="label label-primary">{{vm.customlabels['primary']}}</span>
            </a>
          </li>
          <li role="separator" class="divider" uib-dropdown></li>
          <li uib-dropdown>
            <label for="key{{$index}}">Stichwort</label>
            <input id="key{{$index}}" class="form-control" ng-blur="vm.editKeyword(kw)" ng-model="kw.key" ng-click="$event.stopPropagation()">
          </li>
          <li role="separator" class="divider" uib-dropdown></li>
          <li>
            <a ng-click="vm.removeKeyword(kw)">
              <span class="label label-danger">X</span> Löschen
            </a>
          </li>
        </ul>
      </span>
    </span><!-- ng-repeat -->
  </span>

  <form name="vm.formid" ng-submit="vm.addKeyword()">
        <div class="input-group spacer-top">
            <input class="form-control" ng-model="vm.newkeyword" id="newkeyword"
                   placeholder="Neue Stichwort für diese Konsultation ..."
                   ng-keyup="$event.keyCode == 13 && vm.addKeyword()"
                   ng-blur="vm.addKeyword()"/>
            <span class="input-group-btn">
          <button type="submit" class="btn btn-success"
                  ng-click="vm.addKeyword()"><i class="fa fa-plus"></i></button>
        </span>
        </div>
  </form>


</div>